import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from "../../../../store/actions/main";
import {
       updateStepsTore,
       updateModellTore,
       updateTabIndexTore,
       updateMusterTore
      } from '../../../../store/actions/tore';
import TabSlider from '../../../../module/tabslider_new';
import {fluegeltore_gerade, fluegeltore_geschwungen} from '../../../../../assets/images/tore/fluegeltore/muster';
import {schiebetore_gerade, schiebetore_geschwungen} from '../../../../../assets/images/tore/schiebetore/muster';
import {InputRadio} from '../../../../module/inputRadio';
import scrollToElement from '../../../../module/scrollToElement';


const Step_1 = (props) => {
   const fluegeltore_modell = [fluegeltore_gerade, fluegeltore_geschwungen];
   const schiebetore_modell = [schiebetore_gerade, schiebetore_geschwungen];
   const tore_modell = [schiebetore_modell, fluegeltore_modell];
   const antTabArr = [{titel: 'Gerade'}, {titel: 'Geschwungen'}];
   const [tabIndex, selectTabIndex] = useState(0);
   const [muster, updateMuster] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
         const {index, form, kind, titel, muster} = props.data[props.modell_index].modell[0];
         const {tab_index} = props.data[props.modell_index];
         let tab_wrapper_gerade = document.querySelectorAll('.tab_wrapper_gerade');
         let tab_wrapper_geschwungen = document.querySelectorAll('.tab_wrapper_geschwungen');
         let modal_box_header = document.querySelector('#modal_box_header');

         //update muster description
         if (muster) updateMuster(muster);

         //update tab index
         selectTabIndex(tab_index);

         //scroll to Next Button Container
         scrollToElement();

         //update titel
         if (!muster&&!titel) modal_box_header.innerHTML = kind;
         if (titel&&muster==='Sortiment') modal_box_header.innerHTML = kind+': '+titel;
         if (muster==='Eigenes Muster')  modal_box_header.innerHTML = kind+': Eigenes Muster';

         //remove check of product box
         for(let i=0; i<tab_wrapper_geschwungen.length; i++) {
            tab_wrapper_geschwungen[i].classList.remove('check');
         }
         for(let i=0; i<tab_wrapper_gerade.length; i++) {
            tab_wrapper_gerade[i].classList.remove('check');
         }

         //check of product box
         if (index) {
            if (tab_wrapper_gerade[index] && form === 'Gerade') tab_wrapper_gerade[index].classList.add('check');
            if (tab_wrapper_geschwungen[index] && form === 'Geschwungen') tab_wrapper_geschwungen[index].classList.add('check');
         }

         //update steps
         props.updateSteps(0);
         if (index || muster ==='Eigenes Muster') props.updateSteps(1);

         //Weiter-Button aktivieren
         if (index || muster ==='Eigenes Muster' || props.data[props.modell_index].allVisitedSteps) {
            props.setUpdateButtonActiveStepToFalse();
         } else {
            props.setUpdateButtonActiveStepToTrue();
         }

   }

   const selectForm = ev => {
      let modell_index = ev.currentTarget.getAttribute('index');
      let modell_titel = ev.currentTarget.getAttribute('titel');
      let modell_img = ev.target.currentSrc;
      let modell_form = ev.currentTarget.getAttribute('form');

      let modellObject = {
         index: modell_index,
         titel: modell_titel,
         img: modell_img,
         form: modell_form
      }

      props.updateModell(modellObject);
      updateItems();
   }

   const handleChangeTab = (event, newValue) => {
      selectTabIndex(newValue);
      props.updateTabIndex(newValue);
      updateItems();
   }

   const selectMuster = ev => {
      let muster = ev.target.value;
      updateMuster(muster);
      props.updateMuster(muster);
   }

   let titel = props.data[props.modell_index].modell[0].kind;

   const arrayRadioItems = [
      {labalValue: 'Sortiment', labelTitel: 'Muster aus unserem Sortiment'},
      {labalValue: 'Eigenes Muster', labelTitel: 'Eigenes Muster hochladen'}
   ]

      return (
           <div className="step_wrapper">
             <h2 className="step_header">Wählen Sie ein Muster für Ihr {titel} aus</h2>
              <div className="step_icon_wrapper">
                  <div className="inner_masseMenge_wrapper">
                     <div className="textfield-wrapper">
                        <InputRadio
                           arial_label='Muster'
                           name='Muster'
                           value={muster}
                           onChange={selectMuster}
                           arrayRadioItems={arrayRadioItems}
                        />
                     </div>
                  </div>
                  {muster === 'Sortiment'?
                     <div className="slider_wrapper">
                        <TabSlider
                              antTabArr={antTabArr}
                              tabPanelArr={tore_modell[props.modell_index]}
                              onClick={selectForm}
                              imgClassName='slider_img_tore'
                              tabIndex={tabIndex}
                              handleChangeTab={handleChangeTab}
                        />
                     </div>
                     : ''
                  }
                  {muster === 'Eigenes Muster'?<p>Im lezten Schritt haben Sie die Möglichkeit ein eigenes Muster hochzuladen.</p>:''}
              </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      data: state.toreReducer.data,
      modell_index: state.toreReducer.modell_index
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsTore(ev)),
      updateModell: ev => dispatch(updateModellTore(ev)),
      updateTabIndex: ev => dispatch(updateTabIndexTore(ev)),
      updateMuster: ev => dispatch(updateMusterTore(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_1);
